import { useSelector } from 'react-redux';
import { REDUX_STORE_SLICES } from '../../../../../services/exports/Constants';
import { StoreInterface } from '../../../../../store/types';
import { useForm } from 'react-hook-form';
import { DeliveryAddressSchema, deliveryAddressSchema } from './schema';
import { zodResolver } from '@hookform/resolvers/zod';
import { UseFormProps } from 'react-hook-form/dist/types';

type Props = UseFormProps<DeliveryAddressSchema> & {
  empty?: boolean;
};

const useDeliveryForm = ({ defaultValues, empty, ...rest }: Props = {}) => {
  const cachedOrder = useSelector((state: StoreInterface) => state[REDUX_STORE_SLICES.ORDER].cached_order);
  const getValue = (value: any, defaultValue: any) => (empty || !value ? defaultValue : value);

  return useForm<DeliveryAddressSchema>({
    defaultValues: defaultValues ?? {
      delivery_street_name: getValue(cachedOrder.delivery_street_name, ''),
      delivery_street_number: getValue(cachedOrder.delivery_street_number, ''),
      delivery_city: getValue(cachedOrder.delivery_city, ''),
      delivery_zip_code: getValue(cachedOrder.delivery_zip_code, ''),
      delivery_country: getValue(cachedOrder.delivery_country, null),
      delivery_lat: getValue(+cachedOrder.delivery_lat, undefined),
      delivery_lng: getValue(+cachedOrder.delivery_lng, undefined),
    },
    resolver: zodResolver(deliveryAddressSchema),
    ...rest,
  });
};

export default useDeliveryForm;
